export const GAME_WIDTH = 720;
export const GAME_HEIGHT = 1280;
export const STARTING_PLAYER_X: number = GAME_WIDTH * 0.5;
export const STARTING_PLAYER_Y: number = GAME_HEIGHT * 0.8;
export const DEBUG = false;

export const PLAYER_WIDTH = 86;
export const PLAYER_HEIGHT = 125;
export const PLATFORM_WIDTH = 125;
export const PLATFORM_HEIGHT = 26;

export const PLAYER_CUTOFF = GAME_HEIGHT * 0.55;

export const GUN_DISTANCE_FROM_PLAYER = 100;
export const BULLET_SPEED = 20;



export const MIN_PLATFORM_GAP = 50;
export const MAX_PLATFORM_GAP = 200;